import React from 'react';

type Props = React.PropsWithChildren<{
  condition: boolean;
  wrapper: (children: React.ReactNode) => React.ReactNode;
}>;

export function ConditionalWrap({ condition, children, wrapper }: Props) {
  return condition ? wrapper(children) : children;
}
